module.exports = __webpack_public_path__ + "static/img/poster_bg2.fdcda5f8.png";